import React, { Fragment } from "react";
import { connect } from "react-redux";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import { addToCart, addToWishList } from "../../../store/actions/action";
import ShopProduct from "../../../components/ShopProduct/breakfast";
import api from "../../../api";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import { NavLink } from "react-router-dom";
import Premium from "../../../components/ShopProduct/breakfast/Premium";
import Luxury from "../../../components/ShopProduct/breakfast/Luxury";

const BreakFast = ({ addToCart, addToWishList }) => {
  const productsArray = api();

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product) => {
    addToWishList(product);
  };
  const [breakfast, setBreakfast] = React.useState("standard");

  const products = productsArray;

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-3"} />
      {/* <PageTitle pageTitle={"Breakfast"} pagesub={"Breakfast"} /> */}
      <nav className="toggleNav">
        <ul className="d-flex flex-column flex-sm-row justify-content-center fs-2 ">
          <li
            className={`p-4  ${breakfast == "standard" ? "text-warning" : ""}`}
            id="standard"
            style={{ cursor: "pointer" }}
            onClick={() => setBreakfast("standard")}
          >
            Standard Breakfast
          </li>
          <li className="p-4 cursor-pointer d-none d-sm-block">
            <i className="	fa fa-angle-double-right"></i>
          </li>
          <li
            className={`p-4 cursor-pointer ${
              breakfast == "premium" ? "text-warning" : ""
            }`}
            id="premium"
            style={{ cursor: "pointer" }}
            onClick={() => setBreakfast("premium")}
          >
            Premium BreakFast
          </li>
          <li className="p-4  d-none d-sm-block">
            <i className="	fa fa-angle-double-right"></i>
          </li>
          <li
            className={`p-4 ${breakfast == "luxury" ? "text-warning" : ""}`}
            id="luxury"
            style={{ cursor: "pointer" }}
            onClick={() => setBreakfast("luxury")}
          >
            Luxury Breakfast{" "}
          </li>
        </ul>
      </nav>
      <section className="wpo-shop-page section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {breakfast == "standard" && <ShopProduct />}
              {breakfast == "premium" && <Premium />}
              {breakfast == "luxury" && <Luxury />}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(BreakFast);
